// extracted by mini-css-extract-plugin
export default {"container":"Language_container__bQTtu","button":"Language_button__gVw+b","active":"Language_active__rcJ5s"};